import ConfirmationButtonView from './ConfirmationButtonView';
export default ConfirmationButtonView;
